import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { initialize, updateCommentsOrder, updateEmailSuccess, updateEmail, updateEmailFail, resendVerificationEmail, resendVerificationEmailSuccess, resendVerificationEmailFail, setViewMode, setIsMobile, setThemeSkin, setFeedbackCount, updateAvatar, toggleTheme, setTheme, setChatSettingMuted, setChatSettingOnline, setChatSettingSoundsMuted, updatePointsCount } from './actions';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { reduxKey } from '@wix/da-react-context/pkg/publicSession/constants';
import { siteHeaderWatchOpened, siteHeaderNotesOpened } from '../SiteHeader/redux/actions';
import { awardBadgeSuccess } from '../coreBadge/redux/actionCreators';
const defaultState = {
    isLoggedIn: false
};
const reducer = handleActions({
    [initialize.toString()]: (state, action)=>action.payload ? _object_spread({}, state, action.payload.sessionData) : state,
    [siteHeaderWatchOpened.toString()]: (state)=>state.counts && state.counts.watch ? _object_spread_props(_object_spread({}, state), {
            counts: _object_spread_props(_object_spread({}, state.counts), {
                watch: 0
            })
        }) : state,
    [siteHeaderNotesOpened.toString()]: (state)=>state.counts && state.counts.notes ? _object_spread_props(_object_spread({}, state), {
            counts: _object_spread_props(_object_spread({}, state.counts), {
                notes: 0
            })
        }) : state,
    [updateCommentsOrder.toString()]: (state, { payload })=>payload && payload.order !== state.commentsOrder ? _object_spread_props(_object_spread({}, state), {
            commentsOrder: payload.order
        }) : state,
    [updateAvatar.toString()]: (state, { payload })=>payload && payload.avatar && state.user && typeof state.user !== 'number' ? _object_spread_props(_object_spread({}, state), {
            user: _object_spread_props(_object_spread({}, state.user), {
                usericon: payload.avatar
            })
        }) : state,
    [toggleTheme.toString()]: (state)=>{
        return _object_spread_props(_object_spread({}, state), {
            theme: state.theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT
        });
    },
    [setTheme.toString()]: (state, { payload })=>payload ? _object_spread_props(_object_spread({}, state), {
            theme: payload.theme,
            themeSkin: undefined
        }) : state,
    [setThemeSkin.toString()]: (state, { payload })=>payload ? _object_spread_props(_object_spread({}, state), {
            // If we ever have more skins, parse themeSkin for the base theme
            theme: ThemeOptions.LIGHT,
            themeSkin: payload.themeSkin
        }) : state,
    [setIsMobile.toString()]: (state, { payload: { isMobile } })=>_object_spread_props(_object_spread({}, state), {
            isMobile
        }),
    [setFeedbackCount.toString()]: (state, { payload: count })=>_object_spread_props(_object_spread({}, state), {
            counts: _object_spread_props(_object_spread({}, state.counts), {
                feedback: count
            })
        }),
    [resendVerificationEmail.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isResendInProgress: true
            })
        }),
    [resendVerificationEmailSuccess.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isResendInProgress: false,
                isSendingDone: true
            })
        }),
    [resendVerificationEmailFail.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isResendInProgress: false,
                isSendingDone: false
            })
        }),
    [updateEmail.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isEmailChangeInProgress: true,
                isSendingDone: false
            })
        }),
    [updateEmailSuccess.toString()]: (state, { payload })=>payload ? _object_spread_props(_object_spread({}, state), {
            verificationEmail: payload.email,
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isEmailChangeInProgress: false,
                isSendingDone: true
            })
        }) : state,
    [updateEmailFail.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            updateProgress: _object_spread_props(_object_spread({}, state.updateProgress), {
                isEmailChangeInProgress: false,
                isSendingDone: false,
                updateFailed: true
            })
        }),
    [setViewMode.toString()]: (state, { payload: { nextViewMode } })=>_object_spread_props(_object_spread({}, state), {
            deviationViewMode: nextViewMode
        }),
    [setChatSettingMuted.toString()]: (state, { payload: { value } })=>_object_spread_props(_object_spread({}, state), {
            chat: _object_spread_props(_object_spread({}, state.chat), {
                muted: value
            })
        }),
    [setChatSettingSoundsMuted.toString()]: (state, { payload: { value } })=>_object_spread_props(_object_spread({}, state), {
            chat: _object_spread_props(_object_spread({}, state.chat), {
                muteSound: value
            })
        }),
    [setChatSettingOnline.toString()]: (state, { payload: { value } })=>_object_spread_props(_object_spread({}, state), {
            chat: _object_spread_props(_object_spread({}, state.chat), {
                online: value
            })
        }),
    [awardBadgeSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            counts: _object_spread_props(_object_spread({}, state.counts), {
                fragments: action.payload.newBalance
            })
        }),
    [updatePointsCount.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            counts: _object_spread_props(_object_spread({}, state.counts), {
                points: action.payload.pointsCount
            })
        })
}, defaultState);
export default {
    [reduxKey]: reducer
};

//# sourceMappingURL=reducers.js.map